import useSWRImmutable from 'swr/immutable';

const useInitialLoader = ({name, dataProvider}) => {
    const loader = (name, params, fetcher) => {
        const {data, error} = useSWRImmutable(`/api/${name}/${params.join("/")}`, fetcher)
        return {
            data,
            loading: !error && !data,
            error
        }
    }


    
    
    return loader(
        name, 
        [], 
        Array.isArray(dataProvider) ? () => Promise.resolve(dataProvider) : dataProvider
    )
    
}

export default useInitialLoader;